import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import MyNavbar from '../../../components/Customer/Mynavbar/MyNavbar';
import ProductCard from '../../../components/Customer/ProductCard/ProductCard';
import Footer from '../../../components/Customer/Footer/Footer';
import AppContext from '../../../context/AppContext';
import '../../../assests/css/customer/Women/Women.css'; 

const SaleProductsPage = () => {
  const navigate = useNavigate();
  const { baseUrl, baseUrlForFiles } = useContext(AppContext);
  const [searchParams] = useSearchParams();
  const categoryId = searchParams.get('category');

  const [wishlist, setWishlist]       = useState([]);
  const [cart, setCart]               = useState([]);
  const [allProducts, setAllProducts] = useState([]);
  const [loading, setLoading]         = useState(false);

  useEffect(() => {
    setLoading(true);
    axios.get(`${baseUrl}/customer/products/getSaleProducts`, {
      params: categoryId ? { category_id: categoryId } : {},
    })
      .then((res) => {
        setAllProducts(res.data.products || []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [baseUrl, categoryId]);

  const formatProduct = (product) => {
    const categoryName = (product.category?.category_name || '').toLowerCase();
    const subTitle = (product.subcategory?.title || '')
      .toLowerCase()
      .replace(/[^a-z]/g, '');

    let type = 'stitched';
    if (categoryName === 'accessories' || subTitle.includes('accessor')) {
      type = 'accessories';
    } else if (subTitle.includes('unstit') || subTitle.includes('unstich')) {
      type = 'unstitched';
    }

    return {
      ...product,
      images: product.images?.length > 0
        ? [`${baseUrlForFiles}/${product.images[0].image_path}`]
        : [],
      price: product.discount_price || product.base_price,
      type,
    };
  };

  const toggleWishlist = (id) =>
    setWishlist((prev) => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);

  const toggleCart = (id) =>
    setCart((prev) => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);

  return (
    <div>
      <MyNavbar />
      <br />
      <section className="products-collection-section">
        <div className="products-collection-container">
          <h2 className="products-collection-title">
            {categoryId ? 'Sale Items' : 'All Sale Products'}
          </h2>

          {loading && <p style={{ textAlign: 'center', padding: '20px' }}>Loading...</p>}

          <div className="products-grid">
            {allProducts.map((product) => (
              <ProductCard
                key={product.id}
                product={formatProduct(product)}
                type={formatProduct(product).type}
                wishlist={wishlist}
                toggleWishlist={toggleWishlist}
                cart={cart}
                toggleCart={toggleCart}
                onCardClick={() => navigate(`/product-detail/${product.id}`)}
              />
            ))}
          </div>

          {!loading && allProducts.length === 0 && (
            <p style={{ textAlign: 'center', color: '#999' }}>No sale products found.</p>
          )}
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default SaleProductsPage;